import { createStore } from 'vuex'
import userModule from './User'
import authModule from './Authentication'
import companyModule from './Company'
import locationModule from './Location'
import incomeModule from './Income'
import outcomeModule from './Outcome'
import typesModule from './Types'
import analysisModule from './Analysis'
import agrochemicalModule from './Agrochemical'
import landBatchModule from './LandBatch'
import commodityModule from './Commodity'
import alertDialogModule from './AlertDialog'
import processModule from './Process'

const state = {
  isDrawerMini: true,
  snackBarStatus: { actived: false, message: '', color: 'success' },
  notifiDialog: { actived: false, title: '', body: [] },
  isRefreshTableRequired: false
}

const store = createStore({
  modules: {
    userModule,
    authModule,
    companyModule,
    locationModule,
    incomeModule,
    outcomeModule,
    typesModule,
    analysisModule,
    agrochemicalModule,
    landBatchModule,
    commodityModule,
    alertDialogModule,
    processModule
  },
  state,
  getters: {
    isDrawerMini: state => state.isDrawerMini,
    getSnackBarStatus: state => state.snackBarStatus,
    getNotifiDialog: state => state.notifiDialog,
    isRefreshTableRequired: state => state.isRefreshTableRequired
  },
  actions: {
    changeDrawerSize (context) {
      context.commit('changeDrawerSize')
    },
    setNotificationDialog (context, value) {
      context.commit('setNotificationDialog', value)
    },
    setSnackBarStatus (context, status) {
      context.commit('setSnackBarStatus', status)
    }
  },
  mutations: {
    changeDrawerSize (state) {
      state.isDrawerMini = !state.isDrawerMini
    },
    setSnackBarStatus (state, status) {
      state.isRefreshTableRequired = true
      state.snackBarStatus = status
      setTimeout(function () {
        state.snackBarStatus = {actived: false, message: ''}
        state.isRefreshTableRequired = false
      }, 4000)
    },
    setNotificationDialog (state, value) {
      state.notifiDialog = value
    }
  }
})

export default store
